import React, { useContext } from 'react'
import { When } from 'react-if'
import { UNITED_STATES } from '@/constants/regions'
import { ProjectMetaContext } from '@/contexts/ProjectMetaContext/ProjectMetaContext'
import { useTheatricalRatings } from '@/hooks/useTheatricalRatings'
import { useGetTheatricalReleaseBySlug } from '@/services/ProjectsService'
import { useUserRegion } from '@/services/UserRegionService'
import { RatingItem } from './RatingItem'

export const RatingsSection = () => {
  const { project } = useContext(ProjectMetaContext)
  const { region } = useUserRegion()
  const { theatricalRelease } = useGetTheatricalReleaseBySlug({
    theatricalSlug: project?.slug,
    region: region || UNITED_STATES,
    projectType: project?.projectType,
  })

  const {
    rottenTomatoes,
    audience,
    cinema,
    imdb,
    shouldShowRottenTomatoes,
    shouldShowAudience,
    shouldShowCinema,
    shouldShowImdb,
  } = useTheatricalRatings(theatricalRelease, {
    rottenTomatoes: project?.rottenTomatoes,
    audience: project?.audience,
    cinema: project?.cinema,
    imdb: project?.imdb,
  })

  return (
    <section id="ratings" className="my-4 flex w-full flex-row items-center justify-center lg:justify-start">
      <When condition={shouldShowRottenTomatoes}>
        <RatingItem icon={rottenTomatoes?.icon} rating={rottenTomatoes?.rating} author={rottenTomatoes?.author} />
      </When>
      <When condition={shouldShowAudience}>
        <RatingItem icon={audience?.icon} rating={audience?.rating} author={audience?.author} />
      </When>
      <When condition={shouldShowCinema}>
        <RatingItem icon={cinema?.icon} rating={cinema?.rating} author={cinema?.author} />
      </When>
      <When condition={shouldShowImdb}>
        <RatingItem icon={imdb?.icon} rating={imdb?.rating} author={imdb?.author} />
      </When>
    </section>
  )
}
